<template>
    <button :disabled="loading" class="text-error focus:outline-none" @click="togglePublic()">
        <icon v-if="isPublic" name="check-circle"/>
        <icon v-else name="circle"/>
    </button>
</template>

<script>
export default {
    props: {
        endpoint: {
            type: String,
            required: true
        },
        public: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            isPublic: this.public,
            loading: false
        }
    },

    methods: {
        togglePublic() {
            this.loading = true;
            axios.patch(this.endpoint)
                .then(response => {
                    this.loading = false;
                    this.isPublic = response.data.file.public;
                    if (this.isPublic) {
                        Notify.info('Soubor byl označen jako veřejný');
                    } else {
                        Notify.info('Soubor byl označen jako soukromý');
                    }
                })
                .catch(error => {
                    this.loading = false;
                    if (errors.status === 403) {
                        Notify.error('Nemáte oprávnění měnit nastavení souboru');
                        return;
                    }

                    console.log(errors);
                    alert('unknown error');
                });
        }
    }
}
</script>
